export const ARRANGEMENTS_NO_RESULTS_FOUND = 'arrangements.no_results_found';
export const ARRANGEMENTS_NO_RESULT_SUGGESTION =
  'arrangements.no_results.suggestion';
